/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as LoginCompleteRouteImport } from './routes/login_.complete'
import { Route as AppUsersRouteImport } from './routes/_app.users'
import { Route as AppKitchenSinkRouteImport } from './routes/_app.kitchen-sink'
import { Route as AppAlphaRouteImport } from './routes/_app.alpha'
import { Route as AppWorkflowsIndexRouteImport } from './routes/_app.workflows.index'
import { Route as AppDocumentUploadsIndexRouteImport } from './routes/_app.document-uploads.index'
import { Route as AppCasesIndexRouteImport } from './routes/_app.cases.index'
import { Route as AppAlphaIndexRouteImport } from './routes/_app.alpha.index'
import { Route as AppWorkflowsNewRouteImport } from './routes/_app.workflows.new'
import { Route as AppDocumentUploadsIdRouteImport } from './routes/_app.document-uploads.$id'
import { Route as AppCasesIdRouteImport } from './routes/_app.cases.$id'
import { Route as AppAlphaSettingsRouteImport } from './routes/_app.alpha.settings'
import { Route as AppWorkflowsIdEditRouteImport } from './routes/_app.workflows.$id.edit'
import { Route as AppAlphaThreadsThreadIdRouteImport } from './routes/_app.alpha.threads.$threadId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const LoginCompleteRoute = LoginCompleteRouteImport.update({
  id: '/login_/complete',
  path: '/login/complete',
  getParentRoute: () => rootRouteImport,
} as any)
const AppUsersRoute = AppUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const AppKitchenSinkRoute = AppKitchenSinkRouteImport.update({
  id: '/kitchen-sink',
  path: '/kitchen-sink',
  getParentRoute: () => AppRoute,
} as any)
const AppAlphaRoute = AppAlphaRouteImport.update({
  id: '/alpha',
  path: '/alpha',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkflowsIndexRoute = AppWorkflowsIndexRouteImport.update({
  id: '/workflows/',
  path: '/workflows/',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentUploadsIndexRoute = AppDocumentUploadsIndexRouteImport.update({
  id: '/document-uploads/',
  path: '/document-uploads/',
  getParentRoute: () => AppRoute,
} as any)
const AppCasesIndexRoute = AppCasesIndexRouteImport.update({
  id: '/cases/',
  path: '/cases/',
  getParentRoute: () => AppRoute,
} as any)
const AppAlphaIndexRoute = AppAlphaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAlphaRoute,
} as any)
const AppWorkflowsNewRoute = AppWorkflowsNewRouteImport.update({
  id: '/workflows/new',
  path: '/workflows/new',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentUploadsIdRoute = AppDocumentUploadsIdRouteImport.update({
  id: '/document-uploads/$id',
  path: '/document-uploads/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCasesIdRoute = AppCasesIdRouteImport.update({
  id: '/cases/$id',
  path: '/cases/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAlphaSettingsRoute = AppAlphaSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppAlphaRoute,
} as any)
const AppWorkflowsIdEditRoute = AppWorkflowsIdEditRouteImport.update({
  id: '/workflows/$id/edit',
  path: '/workflows/$id/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppAlphaThreadsThreadIdRoute = AppAlphaThreadsThreadIdRouteImport.update({
  id: '/threads/$threadId',
  path: '/threads/$threadId',
  getParentRoute: () => AppAlphaRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/alpha': typeof AppAlphaRouteWithChildren
  '/kitchen-sink': typeof AppKitchenSinkRoute
  '/users': typeof AppUsersRoute
  '/login/complete': typeof LoginCompleteRoute
  '/alpha/settings': typeof AppAlphaSettingsRoute
  '/cases/$id': typeof AppCasesIdRoute
  '/document-uploads/$id': typeof AppDocumentUploadsIdRoute
  '/workflows/new': typeof AppWorkflowsNewRoute
  '/alpha/': typeof AppAlphaIndexRoute
  '/cases/': typeof AppCasesIndexRoute
  '/document-uploads/': typeof AppDocumentUploadsIndexRoute
  '/workflows/': typeof AppWorkflowsIndexRoute
  '/alpha/threads/$threadId': typeof AppAlphaThreadsThreadIdRoute
  '/workflows/$id/edit': typeof AppWorkflowsIdEditRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/kitchen-sink': typeof AppKitchenSinkRoute
  '/users': typeof AppUsersRoute
  '/login/complete': typeof LoginCompleteRoute
  '/': typeof AppIndexRoute
  '/alpha/settings': typeof AppAlphaSettingsRoute
  '/cases/$id': typeof AppCasesIdRoute
  '/document-uploads/$id': typeof AppDocumentUploadsIdRoute
  '/workflows/new': typeof AppWorkflowsNewRoute
  '/alpha': typeof AppAlphaIndexRoute
  '/cases': typeof AppCasesIndexRoute
  '/document-uploads': typeof AppDocumentUploadsIndexRoute
  '/workflows': typeof AppWorkflowsIndexRoute
  '/alpha/threads/$threadId': typeof AppAlphaThreadsThreadIdRoute
  '/workflows/$id/edit': typeof AppWorkflowsIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/alpha': typeof AppAlphaRouteWithChildren
  '/_app/kitchen-sink': typeof AppKitchenSinkRoute
  '/_app/users': typeof AppUsersRoute
  '/login_/complete': typeof LoginCompleteRoute
  '/_app/': typeof AppIndexRoute
  '/_app/alpha/settings': typeof AppAlphaSettingsRoute
  '/_app/cases/$id': typeof AppCasesIdRoute
  '/_app/document-uploads/$id': typeof AppDocumentUploadsIdRoute
  '/_app/workflows/new': typeof AppWorkflowsNewRoute
  '/_app/alpha/': typeof AppAlphaIndexRoute
  '/_app/cases/': typeof AppCasesIndexRoute
  '/_app/document-uploads/': typeof AppDocumentUploadsIndexRoute
  '/_app/workflows/': typeof AppWorkflowsIndexRoute
  '/_app/alpha/threads/$threadId': typeof AppAlphaThreadsThreadIdRoute
  '/_app/workflows/$id/edit': typeof AppWorkflowsIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/alpha'
    | '/kitchen-sink'
    | '/users'
    | '/login/complete'
    | '/alpha/settings'
    | '/cases/$id'
    | '/document-uploads/$id'
    | '/workflows/new'
    | '/alpha/'
    | '/cases/'
    | '/document-uploads/'
    | '/workflows/'
    | '/alpha/threads/$threadId'
    | '/workflows/$id/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/kitchen-sink'
    | '/users'
    | '/login/complete'
    | '/'
    | '/alpha/settings'
    | '/cases/$id'
    | '/document-uploads/$id'
    | '/workflows/new'
    | '/alpha'
    | '/cases'
    | '/document-uploads'
    | '/workflows'
    | '/alpha/threads/$threadId'
    | '/workflows/$id/edit'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/alpha'
    | '/_app/kitchen-sink'
    | '/_app/users'
    | '/login_/complete'
    | '/_app/'
    | '/_app/alpha/settings'
    | '/_app/cases/$id'
    | '/_app/document-uploads/$id'
    | '/_app/workflows/new'
    | '/_app/alpha/'
    | '/_app/cases/'
    | '/_app/document-uploads/'
    | '/_app/workflows/'
    | '/_app/alpha/threads/$threadId'
    | '/_app/workflows/$id/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  LoginCompleteRoute: typeof LoginCompleteRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/login_/complete': {
      id: '/login_/complete'
      path: '/login/complete'
      fullPath: '/login/complete'
      preLoaderRoute: typeof LoginCompleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/kitchen-sink': {
      id: '/_app/kitchen-sink'
      path: '/kitchen-sink'
      fullPath: '/kitchen-sink'
      preLoaderRoute: typeof AppKitchenSinkRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/alpha': {
      id: '/_app/alpha'
      path: '/alpha'
      fullPath: '/alpha'
      preLoaderRoute: typeof AppAlphaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/workflows/': {
      id: '/_app/workflows/'
      path: '/workflows'
      fullPath: '/workflows/'
      preLoaderRoute: typeof AppWorkflowsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/document-uploads/': {
      id: '/_app/document-uploads/'
      path: '/document-uploads'
      fullPath: '/document-uploads/'
      preLoaderRoute: typeof AppDocumentUploadsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cases/': {
      id: '/_app/cases/'
      path: '/cases'
      fullPath: '/cases/'
      preLoaderRoute: typeof AppCasesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/alpha/': {
      id: '/_app/alpha/'
      path: '/'
      fullPath: '/alpha/'
      preLoaderRoute: typeof AppAlphaIndexRouteImport
      parentRoute: typeof AppAlphaRoute
    }
    '/_app/workflows/new': {
      id: '/_app/workflows/new'
      path: '/workflows/new'
      fullPath: '/workflows/new'
      preLoaderRoute: typeof AppWorkflowsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/document-uploads/$id': {
      id: '/_app/document-uploads/$id'
      path: '/document-uploads/$id'
      fullPath: '/document-uploads/$id'
      preLoaderRoute: typeof AppDocumentUploadsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cases/$id': {
      id: '/_app/cases/$id'
      path: '/cases/$id'
      fullPath: '/cases/$id'
      preLoaderRoute: typeof AppCasesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/alpha/settings': {
      id: '/_app/alpha/settings'
      path: '/settings'
      fullPath: '/alpha/settings'
      preLoaderRoute: typeof AppAlphaSettingsRouteImport
      parentRoute: typeof AppAlphaRoute
    }
    '/_app/workflows/$id/edit': {
      id: '/_app/workflows/$id/edit'
      path: '/workflows/$id/edit'
      fullPath: '/workflows/$id/edit'
      preLoaderRoute: typeof AppWorkflowsIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/alpha/threads/$threadId': {
      id: '/_app/alpha/threads/$threadId'
      path: '/threads/$threadId'
      fullPath: '/alpha/threads/$threadId'
      preLoaderRoute: typeof AppAlphaThreadsThreadIdRouteImport
      parentRoute: typeof AppAlphaRoute
    }
  }
}

interface AppAlphaRouteChildren {
  AppAlphaSettingsRoute: typeof AppAlphaSettingsRoute
  AppAlphaIndexRoute: typeof AppAlphaIndexRoute
  AppAlphaThreadsThreadIdRoute: typeof AppAlphaThreadsThreadIdRoute
}

const AppAlphaRouteChildren: AppAlphaRouteChildren = {
  AppAlphaSettingsRoute: AppAlphaSettingsRoute,
  AppAlphaIndexRoute: AppAlphaIndexRoute,
  AppAlphaThreadsThreadIdRoute: AppAlphaThreadsThreadIdRoute,
}

const AppAlphaRouteWithChildren = AppAlphaRoute._addFileChildren(
  AppAlphaRouteChildren,
)

interface AppRouteChildren {
  AppAlphaRoute: typeof AppAlphaRouteWithChildren
  AppKitchenSinkRoute: typeof AppKitchenSinkRoute
  AppUsersRoute: typeof AppUsersRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCasesIdRoute: typeof AppCasesIdRoute
  AppDocumentUploadsIdRoute: typeof AppDocumentUploadsIdRoute
  AppWorkflowsNewRoute: typeof AppWorkflowsNewRoute
  AppCasesIndexRoute: typeof AppCasesIndexRoute
  AppDocumentUploadsIndexRoute: typeof AppDocumentUploadsIndexRoute
  AppWorkflowsIndexRoute: typeof AppWorkflowsIndexRoute
  AppWorkflowsIdEditRoute: typeof AppWorkflowsIdEditRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAlphaRoute: AppAlphaRouteWithChildren,
  AppKitchenSinkRoute: AppKitchenSinkRoute,
  AppUsersRoute: AppUsersRoute,
  AppIndexRoute: AppIndexRoute,
  AppCasesIdRoute: AppCasesIdRoute,
  AppDocumentUploadsIdRoute: AppDocumentUploadsIdRoute,
  AppWorkflowsNewRoute: AppWorkflowsNewRoute,
  AppCasesIndexRoute: AppCasesIndexRoute,
  AppDocumentUploadsIndexRoute: AppDocumentUploadsIndexRoute,
  AppWorkflowsIndexRoute: AppWorkflowsIndexRoute,
  AppWorkflowsIdEditRoute: AppWorkflowsIdEditRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  LoginCompleteRoute: LoginCompleteRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
